import * as yup from "yup";

import { string } from "@/utils/validation/schemas/general.RHF";

import { LicensePlateTypes } from "./licensePlate.types";

export const LicensePlateValidationSchema = yup.object({
    isPersonalized: yup.boolean().optional(),
    licensePlateType: yup
        .mixed<LicensePlateTypes>()
        .oneOf(Object.values(LicensePlateTypes))
        .required(),
    licensePlate: string().optional()
});

export type LicensePlateFormValues = yup.InferType<
    typeof LicensePlateValidationSchema
>;
